module.exports = __webpack_public_path__ + "9788f41e/img/search-filter-icon.c4751a52.svg";